var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":function($event){$event.preventDefault();return _vm.followLink.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }